import React from 'react';
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { currencyFormat } from '../../js/Functions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleLeft, faAngleDoubleRight, faAngleLeft, faAngleRight, faArrowRight, faCalendarAlt, faDollarSign, faFilter, faHashtag, faSave, faTimes, faUsers } from '@fortawesome/free-solid-svg-icons';

class Crear extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        fecha_factura: '',
        id_paciente: '',
        identificacion_paciente: '',
        paciente: '',
        celular_paciente: '',
        status: '',
        forma_pago: '',
        tipo_pago: '',
        sub_total: '',
        total: 0,
        abono_factura: 0,
        saldo_pendiente: 0,
        restanteFactura: false,
        readOnly: true,
        pacientes: [],
        procedimientos: [],
        procedimientosChecked: [],
        errors: [],
    }
    sessionExpired = () => {
        Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
        window.localStorage.clear();
        window.location.href = '/';
    }
    changeValue = (e) => {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState({ state, errors: [] })
    }
    errorVerify(element) {
        return this.state.errors.indexOf(element) !== -1;
    }
    sendData = async (e) => {
        e.preventDefault();
        const { id_paciente, procedimientosChecked, fecha_factura, forma_pago, tipo_pago, total, abono_factura, readOnly } = this.state;
        var errors = [];
        if (!fecha_factura) { errors.push("error_fecha_factura"); }
        if (!id_paciente) { errors.push("error_id_paciente"); }
        if (!forma_pago) { errors.push("error_forma_pago"); }
        if (!tipo_pago) { errors.push("error_tipo_pago"); }
        let monto_pagado = 0;
        if (tipo_pago === "3") {
            monto_pagado = total;
        } else if (tipo_pago === "2") {
            if (!abono_factura) { errors.push("error_abono_factura"); }
            monto_pagado = abono_factura;
        }
        console.log(errors.length);
        this.setState({ errors: errors });
        if (errors.length > 0) {
            return false;
        }
        if (procedimientosChecked.length === 0) {
            Swal.fire("Atención", "Debe seleccionar al menos un Procedimiento", "warning");
            return;
        }
        var dataFactura = {
            id_paciente: id_paciente,
            fecha_factura: fecha_factura,
            procedimientosChecked: procedimientosChecked,
            forma_pago: forma_pago,
            tipo_pago: tipo_pago,
            monto_pagado: monto_pagado,
            user_id: window.localStorage.getItem('idusuario')
        }
        try {
            Swal.fire({
                title: 'Guardando...',
                text: 'Por favor, Espere',
                allowOutsideClick: false,
                didOpen: () => Swal.showLoading(),
            });
            const FacturaDataRes = await authAxios.post("facturas/register", dataFactura);
            if (!FacturaDataRes.data.status) {
                this.sessionExpired();
                return;
            }
            Swal.close();
            Swal.fire(
                'Facturas!',
                FacturaDataRes.data.message,
                'success'
            );
            this.props.history.push("/UpFacturas/" + FacturaDataRes.data.factura.ID_FACTURA);
        } catch (error) {
            console.error(error);
            Swal.close();
        }
    }
    selectPaciente = (itemPacientes) => {
        Swal.showLoading();
        this.setState({
            id_paciente: itemPacientes.ID_PACIENTE,
            identificacion_paciente: itemPacientes.IDENTIFICACION,
            paciente: itemPacientes.NOMBRE,
            celular_paciente: itemPacientes.CELULAR
        });
        authAxios.get("facturas/listar_procedimientos/" + itemPacientes.ID_PACIENTE)
            .then((dataResult) => {
                console.log(dataResult);
                var status = dataResult.status;
                if (!status) {
                    this.sessionExpired();
                }
                this.setState({
                    procedimientos: dataResult.data.procedimientos,
                    procedimientosChecked: [],
                    total: 0
                });
            })
            .catch(console.log);
        authAxios.get("facturas/saldo_pendiente/" + itemPacientes.ID_PACIENTE)
            .then((dataResult) => {
                console.log(dataResult);
                var status = dataResult.status;
                if (!status) {
                    this.sessionExpired();
                }
                this.setState({
                    saldo_pendiente: dataResult.data.saldo_pendiente
                });
                Swal.close();
            })
            .catch(console.log);
    }
    selectProcedimiento = (procedimiento, checked) => {
        let procedimientosChecked = [...this.state.procedimientosChecked];
        let total = this.state.total;
        if (checked) {
            if (!procedimientosChecked.includes(procedimiento.ID_PROCEDIMIENTO)) {
                procedimientosChecked.push(procedimiento.ID_PROCEDIMIENTO);
                total += parseFloat(procedimiento.PRECIO);
            }
        } else {
            procedimientosChecked = procedimientosChecked.filter(id => id !== procedimiento.ID_PROCEDIMIENTO);
            total -= parseFloat(procedimiento.PRECIO);
        }
        this.setState({
            procedimientosChecked,
            total: total
        })
    }
    calculateTotal = (e) => {
        switch (e.target.value) {
            case '2':
                this.setState({
                    // total: 0,
                    readOnly: false
                })
                break;
            case '3':
                this.setState({
                    // total: 0,
                    readOnly: true
                });
                break;
        }
    }
    ListarPacientes(page) {
        Swal.showLoading();
        let bname_paciente = document.getElementById('bname_paciente').value;
        let btype_paciente = document.getElementById('btype_paciente').value;
        if (bname_paciente == '') {
            bname_paciente = 0;
        }
        if (btype_paciente == '') {
            btype_paciente = 0;
        }
        authAxios.get("historias_clinicas/pacientes/" + btype_paciente + "/" + bname_paciente + "?page=" + page)
            .then((dataResult) => {
                console.log(dataResult);
                Swal.close();
                var status = dataResult.status;
                if (!status) {
                    this.sessionExpired();
                }
                this.setState({
                    pacientes: dataResult.data.data,
                    page_pacientes: dataResult.data.total,
                    last_pacientes: dataResult.data.last_page,
                    current_pacientes: dataResult.data.current_page
                });
            })
            .catch(console.log);
    }
    componentDidMount() {
        this.ListarPacientes(1)
    }
    render() {
        const {
            fecha_factura,
            id_paciente,
            identificacion_paciente,
            paciente,
            celular_paciente,
            forma_pago,
            tipo_pago,
            sub_total,
            total,
            abono_factura,
            saldo_pendiente,
            readOnly,
            restanteFactura,
            pacientes,
            procedimientos,
            procedimientosChecked,
            page_pacientes,
            last_pacientes,
            current_pacientes,
            status } = this.state;
        return (
            <div className="content-wrapper">
                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <div className="card">
                            <div className="card-header text-center">
                                <b>NUEVA FACTURA</b>
                            </div>
                            <div className="card-body">
                                <form onSubmit={this.sendData}>
                                    <div className="row">
                                        <div className="col-xl-12">
                                            <hr style={{ marginBottom: 0, marginTop: 0 }} />
                                            <div style={{ fontSize: 14 }} className="card-header text-center">
                                                <b>INFORMACIÓN FACTURA</b>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-2">
                                                    <label htmlFor="id_factura">No. Factura</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="number" name="id_factura" id="id_factura" 
                                                            className="form-control form-control-sm" placeholder="No. Factura" aria-describedby="helpId"
                                                            onChange={this.changeValue} readOnly />
                                                    </div>
                                                </div>
                                                <div className="col-md-6"></div>
                                                <div className="col-md-2">
                                                    <label htmlFor="fecha_factura">Fecha Factura</label>
                                                    <div className={((this.errorVerify("error_fecha_factura")) ? "is-invalid" : "") + " input-group input-group-sm"}>
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faCalendarAlt} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="date" name="fecha_factura" id="fecha_factura" value={fecha_factura}
                                                            className={((this.errorVerify("error_fecha_factura")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Fecha Factura" aria-describedby="helpId"
                                                            onChange={this.changeValue}
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Seleccione la Fecha Factura</small>
                                                </div>
                                                <div className='col-md-2'>
                                                    <label htmlFor="estado_factura">Estado</label>
                                                    <input style={{ textTransform: 'uppercase', color: "#FFFFFF", backgroundColor: "#00539B", fontWeight: "bold" }} type="text" name="estado_factura" id="estado_factura" value="EN PROCESO"
                                                        className="form-control form-control-sm text-center" placeholder="Estado" aria-describedby="helpId"
                                                        onChange={this.changeValue} readOnly />
                                                </div>
                                            </div>
                                            <hr style={{ marginBottom: 0 }} />
                                            <div style={{ fontSize: 14 }} className="card-header text-center">
                                                <b>INFORMACIÓN PACIENTE</b>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className='col-md-2'>
                                                    <label htmlFor="id_paciente">Identificación</label>
                                                    <div className={((this.errorVerify("error_id_paciente")) ? "is-invalid" : "") + " btn-group"} role="group" aria-label="">
                                                        <button type="button" className="btn btn-primary btn-sm" data-bs-toggle='modal' data-bs-target="#PacientesModal" slot='end'>
                                                            <FontAwesomeIcon icon={faUsers} />
                                                        </button>
                                                        <input type="hidden" name="id_paciente" id="id_paciente" value={id_paciente}  />
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="identificacion_paciente" id="identificacion_paciente" value={identificacion_paciente} 
                                                            className={((this.errorVerify("error_id_paciente")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Identificación" aria-describedby="helpId"
                                                            onChange={this.changeValue} readOnly />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Seleccione un Paciente</small>
                                                </div>
                                                <div className='col-md-4'>
                                                    <label htmlFor="paciente">Paciente</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="paciente" id="paciente" value={paciente}
                                                        className="form-control form-control-sm" placeholder="Paciente" aria-describedby="helpId"
                                                        onChange={this.changeValue} readOnly />
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="celular_paciente">Celular</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="celular_paciente" id="celular_paciente" value={celular_paciente}
                                                            className="form-control form-control-sm" placeholder="Celular" aria-describedby="helpId"
                                                            readOnly />
                                                    </div>
                                                </div>
                                                {
                                                    saldo_pendiente > 0 ?
                                                        <>
                                                            <div className="col-md-2"></div>
                                                            <div className="col-md-2">
                                                                <label htmlFor="saldo_pendiente">Saldo Pendiente</label>
                                                                <div className="input-group input-group-sm">
                                                                    <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                                    <input style={{ textTransform: 'uppercase', backgroundColor: '#DC3545', color: '#FFFFFF', fontWeight: 'bold' }} type="text" name="saldo_pendiente" id="saldo_pendiente" value={currencyFormat(saldo_pendiente)}
                                                                        className="form-control form-control-sm text-center" placeholder="Celular" aria-describedby="helpId"
                                                                        readOnly />
                                                                </div>
                                                            </div>
                                                        </>
                                                    : ''
                                                }
                                            </div>
                                            <hr style={{ marginBottom: 0 }} />
                                            <div style={{ fontSize: 14 }} className="card-header text-center">
                                                <b>PROCEDIMIENTOS</b>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-xl-12">
                                                    <table className="table table-hover table-condensed table-sm">
                                                        <thead className="thead-inverse">
                                                            <tr>
                                                                <th className="align-middle">HISTORIA CLÍNICA</th>
                                                                <th className="align-middle">CATEGORIA</th>
                                                                <th className="align-middle">SERVICIO</th>
                                                                <th className="align-middle">PRECIO</th>
                                                                <th className="align-middle">SELECCIONAR</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                procedimientos.map((itemProcedimientos) => (
                                                                    <tr key={itemProcedimientos.ID_PROCEDIMIENTO }>
                                                                        <td>{itemProcedimientos.ID_HISTORIA_CLINICA}</td>
                                                                        <td>{itemProcedimientos.NOMBRE_CATEGORIA}</td>
                                                                        <td>{itemProcedimientos.NOMBRE_SERVICIO}</td>
                                                                        <td><b>$ </b>{currencyFormat(itemProcedimientos.PRECIO)}</td>
                                                                        <td>
                                                                            <input
                                                                                type="checkbox"
                                                                                onChange={(e) => this.selectProcedimiento(itemProcedimientos, e.target.checked)}
                                                                                checked={this.state.procedimientosChecked.includes(itemProcedimientos.ID_PROCEDIMIENTO)}
                                                                            />
                                                                        </td>
                                                                    </tr>
                                                                ))
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                            <hr style={{ marginBottom: 0 }} />
                                            <div style={{ fontSize: 14 }} className="card-header text-center">
                                                <b>INFORMACIÓN PAGO</b>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                {
                                                    !readOnly ?
                                                        <div className="col-md-4"></div>
                                                    :
                                                        <div className="col-md-6"></div>
                                                }
                                                <div className='col-md-2'>
                                                    <label htmlFor="forma_pago">Forma Pago</label>
                                                    <select name="forma_pago"
                                                        id="forma_pago"
                                                        className={((this.errorVerify("error_forma_pago")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.changeValue}>
                                                        <option value="">Seleccione la Forma de Pago</option>
                                                        <option value="1">EFECTIVO</option>
                                                        <option value="2">TARJETA</option>
                                                        <option value="3">TRANSFERENCIA</option>
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione la Forma de Pago</small>
                                                </div>
                                                <div className='col-md-2'>
                                                    <label htmlFor="tipo_pago">Tipo Pago</label>
                                                    <select name="tipo_pago"
                                                        id="tipo_pago"
                                                        className={((this.errorVerify("error_tipo_pago")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={(e) => {
                                                            this.changeValue(e);
                                                            this.calculateTotal(e);
                                                        }}>
                                                        <option value="">Seleccione un Tipo de Pago</option>
                                                        <option value="2">PAGO PARCIAL</option>
                                                        <option value="3">PAGO TOTAL</option>
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione un Tipo de Pago</small>
                                                </div>
                                                {
                                                    !readOnly ?
                                                        <div className="col-md-2">
                                                            <label htmlFor="abono_factura">Abono Factura</label>
                                                            <div className={((this.errorVerify("error_abono_factura")) ? "is-invalid" : "") + " input-group input-group-sm"}>
                                                                <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                                <input style={{ textTransform: 'uppercase' }} type="number" step="0.01" name="abono_factura" id="abono_factura" value={abono_factura}
                                                                    className={((this.errorVerify("error_abono_factura")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Abono Factura" aria-describedby="helpId"
                                                                    onChange={this.changeValue}
                                                                />
                                                            </div>
                                                            <small id="helpId" className="invalid-feedback">Digite el Abono Factura</small>
                                                        </div>
                                                    : ''
                                                }
                                                <div className="col-md-2">
                                                    <label htmlFor="total">Total</label>
                                                    <div className={((this.errorVerify("error_total")) ? "is-invalid" : "") + " input-group input-group-sm"}>
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="number" step="0.01" name="total" id="total" value={total}
                                                            className={((this.errorVerify("error_total")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Total" aria-describedby="helpId"
                                                            onChange={this.changeValue}
                                                            readOnly
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el Total Factura</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className='row'>
                                        <div className='col-xl-12 text-center'>
                                            <div className="btn-group" role="group" aria-label="">
                                                <button type="submit" className="btn btn-success btn-sm"><FontAwesomeIcon icon={faSave} />&nbsp;&nbsp;Guardar</button>&nbsp;&nbsp;
                                                <Link className="btn btn-danger btn-sm" to={"/MasterFacturas"}><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancelar</Link>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal fade" id="PacientesModal" data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="PacientesModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title w-100 text-center" id="PacientesModalLabel">Pacientes</h4>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-xl-4">
                                        <select name="btype_paciente" id="btype_paciente"
                                            className={"form-select form-select-sm"}>
                                            <option value="">-</option>
                                            <option value="1">PACIENTE</option>
                                            <option value="2">IDENTIFICACIÓN</option>
                                        </select>
                                    </div>
                                    <div className="col-xl-6">
                                        <input style={{ textTransform: 'uppercase' }} type="text" id="bname_paciente" name="bname_paciente" placeholder="Buscar Paciente" className="form-control form-control-sm" />
                                    </div>
                                    <div className="col-xl-2">
                                        <button id="bt" name="bt" className="btn btn-secondary btn-sm" onClick={() => this.ListarPacientes(1)}><FontAwesomeIcon icon={faFilter} />&nbsp;&nbsp;Filtrar</button>
                                    </div>
                                </div>
                                <br />
                                <div className='row'>
                                    <div className='col-xl-12'>
                                        <table className="table table-hover table-condensed table-sm">
                                            <thead className="thead-inverse">
                                                <tr>
                                                    <th className="align-middle">PACIENTE</th>
                                                    <th className="align-middle">IDENTIFICACIÓN</th>
                                                    <th className="align-middle">CELULAR</th>
                                                    <th className="align-middle">SELECCIONAR</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    pacientes.map((itemPacientes) => (
                                                        <tr key={itemPacientes.ID_PACIENTE}>
                                                            <td>{itemPacientes.NOMBRE}</td>
                                                            <td>{itemPacientes.IDENTIFICACION}</td>
                                                            <td>{itemPacientes.CELULAR}</td>
                                                            <td>
                                                                <div className="btn-group" role="group" aria-label="">
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-primary btn-sm"
                                                                        data-bs-dismiss="modal"
                                                                        onClick={() =>
                                                                            this.selectPaciente(itemPacientes)
                                                                        }
                                                                    >
                                                                        <FontAwesomeIcon icon={faArrowRight} />
                                                                    </button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <nav aria-label="Page navigation example">
                                    <ul style={{ marginBottom: 0 }} className="pagination">
                                        <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarPacientes(1)}><FontAwesomeIcon icon={faAngleDoubleLeft} /></a></li>
                                        <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarPacientes(current_pacientes - 1)}><FontAwesomeIcon icon={faAngleLeft} /></a></li>
                                        {(() => {
                                            let p = [];
                                            p.push(<li className="page-item" key={current_pacientes}><a className="page-link" href="#" onClick={() => this.ListarPacientes(current_pacientes)}>{current_pacientes}</a></li>);
                                            return p;
                                        })()}
                                        <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarPacientes(current_pacientes + 1)}><FontAwesomeIcon icon={faAngleRight} /></a></li>
                                        <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarPacientes(last_pacientes)}><FontAwesomeIcon icon={faAngleDoubleRight} /></a></li>
                                    </ul>
                                </nav>
                            </div>
                            <div style={{ justifyContent: 'left' }} className="modal-footer text-muted">
                                <b>Page</b> <span className="badge bg-primary">{current_pacientes}</span> <b>of</b> <span className="badge bg-primary">{last_pacientes}</span> | <b>Records</b> <span className="badge bg-success">{page_pacientes}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Crear;